import { LightSourceType } from '@shared/types/api/externalDamage';
export const LIGHT_SOURCE_TYPE_TITLE = 'claim.declaration.external_damages.form.light_source.title';
export const DEFAULT_LIGHT_SOURCE_TYPE_TRAD_KEYS = {
    [LightSourceType.BollardLight]: 'claim.declaration.external_damages.form.light_source.bollard_light',
    [LightSourceType.WallLamp]: 'claim.declaration.external_damages.form.light_source.wall_lamp',
    [LightSourceType.OutdoorSpotlight]: 'claim.declaration.external_damages.form.light_source.outdoor_spotlight',
    [LightSourceType.StreetLamp]: 'claim.declaration.external_damages.form.light_source.street_lamp',
};
